// src/components/Entity/EntityEditPageRoute.js
// Standalone route wrapper for EntityEditPage
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import EntityEditPage from './EntityEditPage';

function EntityEditPageRoute() {
  const { id } = useParams();
  const navigate = useNavigate();

  const handleClose = () => {
    // If opened in a new tab, close the tab
    if (window.opener) {
      window.close();
    } else {
      // Otherwise navigate back to home
      navigate('/');
    }
  };

  const handleSave = () => {
    // Stay on page after save in standalone mode
    // User can manually close or navigate away
  };

  return (
    <EntityEditPage
      entityId={parseInt(id)}
      onClose={handleClose}
      onSave={handleSave}
      standalone={true}
    />
  );
}

export default EntityEditPageRoute;
